export default __webpack_public_path__ + "static/media/facebook.4482c462.svg";